import React from 'react';

import { useSnackbar } from 'notistack';

import LinkIcon from '@mui/icons-material/Link';
import { Button } from '@mui/material';

export default function ChatTraceTurnLink({
  turnId,
  turnNumber,
  messageId,
}: {
  turnId: string;
  turnNumber: number;
  messageId?: string;
}) {
  const { enqueueSnackbar } = useSnackbar();
  const targetLabel = messageId ? `assistant message in turn ${turnNumber}` : `turn ${turnNumber}`;

  async function copyLink() {
    const url = new URL(window.location.href);
    url.searchParams.set('turnId', turnId);
    url.searchParams.delete('chatId');
    url.searchParams.delete('messageId');
    if (messageId) {
      url.searchParams.set('messageId', messageId);
    }
    url.hash = '';
    try {
      await navigator.clipboard.writeText(url.toString());
      enqueueSnackbar(`Link to ${targetLabel} copied`, { variant: 'success' });
    } catch {
      enqueueSnackbar('Could not copy the link. Please try again.', { variant: 'error' });
    }
  }

  return (
    <Button
      size="small"
      variant="text"
      startIcon={<LinkIcon />}
      aria-label={`Copy link to ${targetLabel}`}
      onClick={copyLink}
      sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
    >
      Copy link
    </Button>
  );
}
